// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_apply__CvjRf {
  background-color: var(--accent);
  color: var(--accent-text);
  font-weight: 600;
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  border: none;
  transition: background-color 0.15s ease;
}

.Header_apply__CvjRf:hover,
.Header_apply__CvjRf:focus {
  background-color: var(--accent-strong);
  color: var(--accent-text);
}

`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;;EAEE,sCAAsC;EACtC,yBAAyB;AAC3B","sourcesContent":[".apply {\n  background-color: var(--accent);\n  color: var(--accent-text);\n  font-weight: 600;\n  font-size: 1rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 4px;\n  border: none;\n  transition: background-color 0.15s ease;\n}\n\n.apply:hover,\n.apply:focus {\n  background-color: var(--accent-strong);\n  color: var(--accent-text);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"apply": `Header_apply__CvjRf`
};
export default ___CSS_LOADER_EXPORT___;
